export default "__VITE_ASSET__C_woLy1C__"